const handleDeletePlaceModalPlaces = {
  confirmTrue: 'No puede eliminar este lugar porque tiene ',
  true: 'equipos',
  false: 'hijos',
  text: 'eliminelos antes.',
  titleTrue: 'ELIMINAR LUGAR',
  confirmFalse: '¿Realmente desea eliminar este lugar?',
  titleFalse: 'ELIMINAR LUGAR',
};

export default handleDeletePlaceModalPlaces;
